import { inject } from '@angular/core';
import { AuthenticationLevels, AuthRedirectService } from '../util-auth-redirect/auth-redirect.service';

/**
 * This allows logged in agent admins to see both Individual and Office pages. Not sure if that is correct, but it is current bahaviour
 */
export function hasAuthTypeOrRedirectGuard(level: AuthenticationLevels) {
  return () => {
    const authService = inject(AuthRedirectService);
    return authService.hasAuthOrRedirect(level);
  };
}
